<template>
    <div>
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
            <a-form-item label="会员状态">
                <a-select v-model="dataForm.enable" placeholder="会员状态" allowClear style="width: 180px;">
                    <a-select-option value="1">有效</a-select-option>
                    <a-select-option value="2">无效</a-select-option>
                    <a-select-option value="3">退会效</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getDataList">搜索</a-button>
            </a-form-item>
            <a-form-item v-permission="['admin:member:create']">
                <a-button type="primary" @click="addOrUpdateHandle({ member_id: '', customer_id })">新增</a-button>
            </a-form-item>
        </a-form>
        <memberTable :customer_id="customer_id" :columns="columns" :dataList="dataList"
            :dataListLoading="dataListLoading" :x="1750" @addOrUpdateHandle="addOrUpdateHandle"
            @deleteHandle="deleteHandle"></memberTable>
        <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/memberaddorupdate.vue";
import memberTable from "./memberTable.vue";

export default {
    mixins: [viewModule],
    components: {
        addorupdate,
        memberTable
    },
    props: {
        customer_id: String,
    },
    watch: {
        customer_id(newValue) {
            this.dataForm.customer_id = newValue
            this.getDataList()
        }
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/admin/member/page",
                deleteURL: "/admin/member/delete",
            },
            dataForm: {
                customer_id: this.customer_id,
                enable: undefined
            },
            columns: [
                {
                    title: "会员等级",
                    dataIndex: "vip_key",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "缴费金额",
                    dataIndex: "pay_price",
                    width: 100,
                    align: 'center'
                },
                {
                    title: "缴费时间",
                    dataIndex: "pay_time",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "会员有效性",
                    dataIndex: "enable",
                    width: 120,
                    align: 'center',
                    scopedSlots: { customRender: "enable" },
                },
                {
                    title: "入会福利",
                    dataIndex: "pay_benefit",
                    width: 200,
                    align: 'center',
                    ellipsis: true
                },
                {
                    title: "入会操作人",
                    dataIndex: "user.real_name",
                    width: 120,
                    align: 'center'
                },
                {
                    title: "费用核对状态",
                    dataIndex: "process_status",
                    scopedSlots: { customRender: "process_status" },
                    width: 150,
                    align: 'center'
                },
                {
                    title: "备注",
                    dataIndex: "remark",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "创建时间",
                    dataIndex: "create_time",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    fixed: 'right'
                },
            ],
        };
    },
    methods: {
        addOrUpdateHandle({ member_id, customer_id, readonly }) {
            this.$refs.addOrUpdate.init({ member_id, customer_id, readonly });
        },
        showView(url) {
            this.$viewerApi({
                images: [url],
            });
        },
    },
};
</script>

<style></style>